// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M3.0043 1.58995L3.00017 1.58582L1.58594 3.00001L4.26534 5.67948C2.32933 7.20644 0.85591 9.29359 0.0892162 11.696L-0.0078125 12L0.0892162 12.304C1.69842 17.3464 6.42102 21 11.9996 21C14.1886 21 16.2457 20.4374 18.0347 19.4492L20.9997 22.4142L22.4097 21.0043L3 1.59425L3.0043 1.58995ZM7 12C7 10.9809 7.30488 10.033 7.82839 9.24261L9.29236 10.7066C9.10495 11.0982 9 11.5369 9 12C9 13.6569 10.3431 15 12 15C12.4631 15 12.9017 14.8951 13.2933 14.7077L14.7573 16.1717C13.9669 16.6951 13.019 17 12 17C9.23858 17 7 14.7614 7 12Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21.1978 16.964C22.4149 15.6419 23.3505 14.0569 23.9099 12.304L24.007 12L23.9099 11.696C22.3007 6.65364 17.5781 3 11.9996 3C10.5695 3 9.19574 3.24009 7.91622 3.68212L11.2848 7.05077C11.5184 7.01731 11.7572 7 12 7C14.7614 7 17 9.23858 17 12C17 12.2429 16.9827 12.4817 16.9492 12.7153L21.1978 16.964Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M14.2531 10.0191C14.1683 9.92272 14.0773 9.83179 13.9809 9.74696L14.2531 10.0191Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-browse-off-filled')
export default class BrowseOffFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'browse-off-filled',
    }
  }
}
